import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authApiClient, endSession } from "../../../utils/axios";
import { showSnackbar } from "../../../api/snackbarSlice";
import useDocumentTitle from "../../../hooks/useDocumentTitle";

const AccountSection = () => {
  useDocumentTitle("Account Section");
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleContinue = () => {
    setLoading(true);
    authApiClient
      .post("/forgot-password", { email: user.email })
      .then((res) => {
        endSession();
        setTimeout(() => {
          navigate("/forgot-password", {
            state: { email: user.email, stage: "verification" },
            replace: true,
          });
          dispatch(
            showSnackbar({
              message: "OTP sent successfully",
              severity: "success",
            }),
          );
        }, 0);
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: "Something went wrong.",
            severity: "error",
          }),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Paper elevation={0} sx={{ p: "1rem" }}>
        <Box sx={{ mb: "1.5rem" }}>
          <Typography variant="h6">{"Security"}</Typography>
          <Divider></Divider>
        </Box>
        <Grid container>
          <Grid size={12}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {
                "Change your current password that you use to login to this account."
              }
            </Typography>
            <Button variant="contained" onClick={() => setOpen(true)}>
              {"Reset Password"}
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Modal open={open} onClose={handleClose}>
        <Paper
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            padding: 16,
            boxShadow: 24,
            outline: "none",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">{"Reset Password"}</Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
          <Divider />

          <Typography variant="body1" mt={2} mb={2}>
            {"You will be logged out & redirected to {link}".replace(
              "{link}",
              "Reset Password",
            )}
          </Typography>
          <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={handleContinue}>
              {loading ? "Processing..." : "Continue"}
            </Button>
          </Stack>
        </Paper>
      </Modal>
    </>
  );
};

export default AccountSection;
